interface PostSummaryBoxProps {
  items: string[];
}

export function PostSummaryBox({ items }: PostSummaryBoxProps) {
  if (!items || items.length === 0) return null;

  return (
    <div className="my-8 bg-[#F0EBE3] border border-[#D4C9BE] rounded-lg p-5 sm:p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-checkbox-circle-line text-[#5B7B6F] text-base"></i>
        </div>
        <p
          className="text-xs font-semibold text-[#5B7B6F] tracking-wide uppercase"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          この記事でわかること
        </p>
      </div>
      <ul className="space-y-2.5">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <span
              className="text-xs font-bold text-[#5B7B6F] mt-0.5 flex-shrink-0 w-4"
              style={{ fontFamily: "'Georgia', serif" }}
            >
              {String(index + 1).padStart(2, '0')}
            </span>
            <span
              className="text-sm text-[#4A3F35] leading-relaxed"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
